// API
import { tmxApiCall } from './index'

export default {
  async update (incomeList, isCustomerInBankruptcy, activeDuty, employmentPerWeek, employmentLength, existingFlexLoan, applicationId) {
    return tmxApiCall('put', '/income', {
      incomeList,
      isCustomerInBankruptcy,
      activeDuty,
      employmentPerWeek,
      employmentLength,
      existingFlexLoan,
      applicationId
    })
  },

  async updateExpenses (applicationId, grossMonthlyIncome, netMonthlyIncome, grossMonthlyExpenses, rent, utilities, insurance, otherExpenses) {
    return tmxApiCall('put', '/expenses', {
      applicationId,
      grossMonthlyIncome,
      netMonthlyIncome,
      grossMonthlyExpenses,
      rent,
      utilities,
      insurance,
      otherExpenses
    })
  }
}
